module.exports = __webpack_public_path__ + "static/elizabeth-street-78c631e1da35b1f5bb873a11df8d620b.jpg";